import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private showGlobalLoaderSubject = new BehaviorSubject<boolean>(false);

  get isGlobalLoaderDisplayed$(): Observable<boolean> {
    return this.showGlobalLoaderSubject.asObservable();
  }

  showGlobalLoader(): void {
    this.showGlobalLoaderSubject.next(true);
  }

  hideGlobalLoader(): void {
    this.showGlobalLoaderSubject.next(false);
  }
}
